import { app_permissions } from './app-permissions';
import { PermissionService } from './permission.service';

export interface AppMenuPermissions {
    canViewProfile: boolean;
    canViewAiChat: boolean;
    canViewWasenderChat: boolean;
    canViewNotifications: boolean;
    canViewTasks: boolean;
    canViewIncidents: boolean;
    canViewReportBuilder: boolean;
    canViewWorkspace: boolean;
    canViewPettyCash: boolean;
    canViewAudit: boolean;
    canViewHr: boolean;
    canViewHrDashboard: boolean;
    canViewHrEmployees: boolean;
    canViewHrOnboarding: boolean;
    canViewHrRecruitment: boolean;
    canViewHrLearning: boolean;
    canViewHrLabor: boolean;
    canViewHrPerformance: boolean;
    canViewHrCases: boolean;
    canViewHrSelf: boolean;
    canViewHrManager: boolean;
    canViewHrAnalytics: boolean;
    canViewHrLifecycle: boolean;
    canViewHrDocuments: boolean;
    canViewHrAdminOperations: boolean;
    canViewHrDocumentTypes: boolean;
    canViewHrReadiness: boolean;
    canViewHrLeave: boolean;
    canViewHrTime: boolean;
    canViewHrBiometric: boolean;
    canViewHrCountryPacks: boolean;
    canViewHrRoster: boolean;
    canViewHrPayroll: boolean;
    canViewHrSetup: boolean;
    canViewHrMigration: boolean;
    canViewCrmDashboard: boolean;
    canViewCrmLeads: boolean;
    canViewCrmProspects: boolean;
    canViewCrmClients: boolean;
    canViewCrmAccounts: boolean;
    canViewCrmMerchandisers: boolean;
    canViewCrmAssignments: boolean;
    canViewCrmQuotations: boolean;
    canManageCustomerPortalAccess: boolean;
    canViewCrm: boolean;
    canViewContracts: boolean;
    canViewPartyClients: boolean;
    canViewPartyContacts: boolean;
    canViewPartners: boolean;
    canViewCommercial: boolean;
    canViewShipmentDashboard: boolean;
    canCreateShipment: boolean;
    canImportShipments: boolean;
    canViewDeliveryRateCards: boolean;
    canViewInternalTransportCosts: boolean;
    canViewShipments: boolean;
    canViewShipmentDeliveries: boolean;
    canViewTransportReleases: boolean;
    canViewTransportPlans: boolean;
    canCreateTransportPlans: boolean;
    canViewShipmentOrders: boolean;
    canViewClearance: boolean;
    canCreateClearance: boolean;
    canViewClearanceServices: boolean;
    canViewCustomsClearance: boolean;
    canViewContainerDashboard: boolean;
    canViewContainerCases: boolean;
    canViewContainerSetup: boolean;
    canViewContainerTracking: boolean;
    canViewShipmentSection: boolean;
    canViewPosmProjects: boolean;
    canViewLogisticsProjects: boolean;
    canViewFieldWork: boolean;
    canViewFieldWorkEquipment: boolean;
    canViewFieldWorkRates: boolean;
    canViewFieldWorkFinance: boolean;
    canViewWarehousingOverview: boolean;
    canViewWarehousingItems: boolean;
    canViewWarehousingStockEntry: boolean;
    canViewWarehousingStock: boolean;
    canViewWarehousingDispatch: boolean;
    canViewWarehousingTransfer: boolean;
    canViewWarehousingRefurbishment: boolean;
    canViewWarehousingDestruction: boolean;
    canViewWarehousingBilling: boolean;
    canViewWarehousing: boolean;
    canViewProjectsAndWarehousing: boolean;
    canViewFleetDashboard: boolean;
    canViewFleetDrivers: boolean;
    canViewFleetVehicles: boolean;
    canViewFleetDocuments: boolean;
    canViewFleetProfitability: boolean;
    canViewFleetTelematics: boolean;
    canManageFleetTelematics: boolean;
    canViewFleetGps: boolean;
    canViewFleetTrailers: boolean;
    canViewFleetTrailerTypes: boolean;
    canViewFleetRentals: boolean;
    canViewFleetRentalUsage: boolean;
    canViewFleetRentalSettlements: boolean;
    canViewMobilizationOverview: boolean;
    canViewMobilizationEntries: boolean;
    canViewMobilizationPlanning: boolean;
    canCreateMobilizationEntry: boolean;
    canViewMobilizationChangeRequests: boolean;
    canViewMobilizationHistory: boolean;
    canViewMobilizationTimesheets: boolean;
    canViewMobilizationSalaryRules: boolean;
    canViewFleetMobilization: boolean;
    canViewMaintenanceOverview: boolean;
    canViewMaintenanceWorkOrders: boolean;
    canViewMaintenancePreventive: boolean;
    canViewMaintenanceInspections: boolean;
    canViewMaintenanceParts: boolean;
    canViewMaintenanceAvailability: boolean;
    canViewMaintenanceAnalytics: boolean;
    canViewFleetMaintenance: boolean;
    canViewFuelManagementOverview: boolean;
    canViewFuelMarketplace: boolean;
    canManageFuelConnections: boolean;
    canViewFuelTransactions: boolean;
    canReconcileFuelTransactions: boolean;
    canViewFuelReports: boolean;
    canViewFuelManagement: boolean;
    canViewFleet: boolean;
    canViewFinanceDashboard: boolean;
    canViewChartOfAccounts: boolean;
    canViewOrders: boolean;
    canViewSalesOrders: boolean;
    canViewPurchaseOrders: boolean;
    canViewExpenses: boolean;
    canCreateExpense: boolean;
    canViewExpenseApprovals: boolean;
    canViewExpensePosting: boolean;
    canViewFinanceExpenses: boolean;
    canViewReceivablesToInvoice: boolean;
    canCreateManualReceivableLine: boolean;
    canViewCustomerInvoices: boolean;
    canCreateManualInvoiceDraft: boolean;
    canViewCustomerReceipts: boolean;
    canViewDebitNotes: boolean;
    canViewReceivables: boolean;
    canViewPayablesToBill: boolean;
    canCreateManualPayableLine: boolean;
    canViewVendorBills: boolean;
    canViewApMatching: boolean;
    canManageMatchingPolicies: boolean;
    canViewPaymentProposals: boolean;
    canViewVendorStatements: boolean;
    canCreateNonPoBillDraft: boolean;
    canViewVouchers: boolean;
    canViewCreditNotes: boolean;
    canViewPayables: boolean;
    canViewBankAccounts: boolean;
    canViewBanks: boolean;
    canViewPaymentTransactions: boolean;
    canViewWorkforceFinance: boolean;
    canViewBankReconciliationDashboard: boolean;
    canViewBankStatements: boolean;
    canViewReconciliationReports: boolean;
    canManageReconciliationRules: boolean;
    canManageReconciliationExceptions: boolean;
    canViewBanking: boolean;
    canViewJournalEntries: boolean;
    canViewCostCenters: boolean;
    canManageAccountingPeriodLocks: boolean;
    canManageManualEntryControls: boolean;
    canViewAccountingControls: boolean;
    canViewGeneralLedger: boolean;
    canViewPartnerLedger: boolean;
    canViewLedgers: boolean;
    canViewAccounting: boolean;
    canViewFinanceReports: boolean;
    canViewAccountsPayableInvoices: boolean;
    canViewAccountsPayableReceipts: boolean;
    canViewAccountsPayable: boolean;
    canViewFinance: boolean;
    canManageSubscription: boolean;
    canViewRegions: boolean;
    canViewLocationZones: boolean;
    canViewWarehouses: boolean;
    canViewLocations: boolean;
    canViewCompanySettings: boolean;
    canViewCompanyGroups: boolean;
    canManageTenantMasterDataImport: boolean;
    canViewCompanySetup: boolean;
    canViewProducts: boolean;
    canConfigureExpenseWorkflow: boolean;
    canViewFinanceSetup: boolean;
    canManageWorkflow: boolean;
    canManageFlexFields: boolean;
    canViewWasenderSetup: boolean;
    canViewBusinessEvents: boolean;
    canViewDeveloperPlatform: boolean;
    canViewSystemSetup: boolean;
    canManageWarehousingStorageRates: boolean;
    canViewWarehousingSetup: boolean;
    canViewWarehousingSetupMenu: boolean;
    canViewAdministration: boolean;
}

export function resolveAppMenuPermissions(permissionService: PermissionService): AppMenuPermissions {
    const has = (permissionCode: string): boolean => permissionService.hasPermission(permissionCode);
    const hasAnyScope = (permissionCode: string): boolean => permissionService.hasPermission(permissionCode, 'ANY');
    const hasAll = (permissionCodes: string[]): boolean => permissionCodes.every(permissionCode => has(permissionCode));

    const canViewProfile = has(app_permissions.customer.records.view);
    const canViewAiChat = has(app_permissions.ai_chat.view);
    const canViewWasenderChat = has(app_permissions.wasender.chat.view);
    const canViewNotifications = has(app_permissions.productivity.notifications.view);
    const canViewTasks = has(app_permissions.productivity.tasks.view);
    const canViewIncidents = has(app_permissions.productivity.incidents.view);
    const canViewReportBuilder = true;
    const canViewAudit = hasAnyScope(app_permissions.audit.dashboard.view);
    const canViewHrDashboard = hasAnyScope(app_permissions.hr.dashboard.view);
    const canViewHrEmployees = has(app_permissions.hr.employees.view);
    const canViewHrOnboarding = has(app_permissions.hr.onboarding.view);
    const canViewHrRecruitment = has(app_permissions.hr.recruitment.view);
    const canViewHrLearning = has(app_permissions.hr.learning.view);
    const canViewHrLabor = has(app_permissions.hr.labor.view);
    const canViewHrPerformance = has(app_permissions.hr.performance.view);
    const canViewHrCases = has(app_permissions.hr.cases.view);
    const canViewHrSelf = has(app_permissions.hr.self.view);
    const canViewHrManager = has(app_permissions.hr.manager.view);
    const canViewHrAnalytics = has(app_permissions.hr.analytics.view);
    const canViewHrLifecycle = has(app_permissions.hr.lifecycle.view);
    const canViewHrDocuments = has(app_permissions.hr.documents.view);
    const canViewHrAdminOperations = hasAnyScope(app_permissions.hr.adminOperations.view);
    const canViewHrDocumentTypes = has(app_permissions.hr.documentTypes.view);
    const canViewHrReadiness = has(app_permissions.hr.readiness.view);
    const canViewHrLeave = has(app_permissions.hr.leave.view);
    const canViewHrTime = has(app_permissions.hr.time.view);
    const canViewHrBiometric = has(app_permissions.hr.biometric.view);
    const canViewHrCountryPacks = has(app_permissions.hr.countryPacks.view);
    const canViewHrRoster = has(app_permissions.hr.roster.view);
    const canViewHrPayroll = has(app_permissions.hr.payroll.view);
    const canViewHrSetup = has(app_permissions.hr.org.view);
    const canViewHrMigration = has(app_permissions.hr.migration.view);
    const canViewHr = canViewHrDashboard
        || canViewHrEmployees
        || canViewHrOnboarding
        || canViewHrRecruitment
        || canViewHrLearning
        || canViewHrLabor
        || canViewHrPerformance
        || canViewHrCases
        || canViewHrSelf
        || canViewHrManager
        || canViewHrAnalytics
        || canViewHrLifecycle
        || canViewHrDocuments
        || canViewHrAdminOperations
        || canViewHrDocumentTypes
        || canViewHrReadiness
        || canViewHrLeave
        || canViewHrTime
        || canViewHrBiometric
        || canViewHrCountryPacks
        || canViewHrRoster
        || canViewHrPayroll
        || canViewHrSetup
        || canViewHrMigration;

    const canViewCrmDashboard = hasAnyScope(app_permissions.crm.dashboard.view);
    const canViewCrmLeads = has(app_permissions.crm.leads.view);
    const canViewCrmProspects = has(app_permissions.crm.prospects.view);
    const canViewCrmClients = has(app_permissions.crm.clients.view);
    const canViewCrmAccounts = has(app_permissions.crm.accounts.view);
    const canViewCrmMerchandisers = has(app_permissions.crm.merchandisers.view);
    const canViewCrmAssignments = has(app_permissions.crm.assignments.view);
    const canViewCrmQuotations = has(app_permissions.crm.quotations.view);
    const canManageCustomerPortalAccess = permissionService.hasAnyPermission([
        app_permissions.portal.admin.manage,
        app_permissions.customer.records.edit,
        app_permissions.customer.records.create
    ]);
    const canViewCrm = canViewCrmDashboard
        || canViewCrmLeads
        || canViewCrmProspects
        || canViewCrmClients
        || canViewCrmAccounts
        || canViewCrmMerchandisers
        || canViewCrmAssignments
        || canViewCrmQuotations
        || canManageCustomerPortalAccess;
    const canViewContracts = has(app_permissions.contracts.records.view);
    const canViewPartyClients = has(app_permissions.party.records.view);
    const canViewPartyContacts = has(app_permissions.party.records.view);
    const canViewPartners = canViewPartyClients || canViewPartyContacts;
    const canViewCommercial = canViewCrm || canViewContracts || canViewPartners;

    const canViewShipmentDashboard = hasAnyScope(app_permissions.shipments.dashboard.view);
    const canCreateShipment = has(app_permissions.shipments.CREATE);
    const canImportShipments = has(app_permissions.shipments.import);
    const canViewDeliveryRateCards = has(app_permissions.contracts.rate_cards.view);
    const canViewInternalTransportCosts = has(app_permissions.shipments.internal_transport_costs.view);
    const canViewShipments = has(app_permissions.shipments.view);
    const canViewShipmentDeliveries = has(app_permissions.shipments.deliveries.view);
    const canViewTransportReleases = has(app_permissions.transport_planning.releases.view);
    const canViewTransportPlans = has(app_permissions.transport_planning.plans.view);
    const canCreateTransportPlans = has(app_permissions.transport_planning.plans.create);
    const canViewShipmentOrders = canViewShipmentDashboard
        || canCreateShipment
        || canImportShipments
        || canViewDeliveryRateCards
        || canViewInternalTransportCosts
        || canViewShipments
        || canViewShipmentDeliveries
        || canViewTransportReleases
        || canViewTransportPlans
        || canCreateTransportPlans;

    const canViewClearance = has(app_permissions.clearance.records.view);
    const canCreateClearance = has(app_permissions.clearance.records.create);
    const canViewClearanceServices = has(app_permissions.clearance.services.view);
    const canViewCustomsClearance = canViewClearance || canCreateClearance || canViewClearanceServices;

    const canViewContainerDashboard = hasAnyScope(app_permissions.container_tracking.dashboard.view);
    const canViewContainerCases = has(app_permissions.container_tracking.cases.view);
    const canViewContainerSetup = has(app_permissions.container_tracking.yards.view);
    const canViewContainerTracking = canViewContainerDashboard || canViewContainerCases || canViewContainerSetup;
    const canViewShipmentSection = canViewShipmentOrders || canViewCustomsClearance || canViewContainerTracking;

    const canViewPosmProjects = has(app_permissions.posm.projects.view);
    const canViewLogisticsProjects = has(app_permissions.logisticsProjects.projects.view);
    const canViewFieldWork = has(app_permissions.operations.fieldWork.view);
    const canViewFieldWorkEquipment = has(app_permissions.operations.equipment.view);
    const canViewFieldWorkRates = has(app_permissions.operations.equipment.ratesView);
    const canViewFieldWorkFinance = has(app_permissions.operations.fieldWork.financeView);
    const canViewWarehousingOverview = hasAnyScope(app_permissions.warehousing.overview.view);
    const canViewWarehousingItems = has(app_permissions.warehousing.items.view);
    const canViewWarehousingStockEntry = has(app_permissions.warehousing.stock_entry.view);
    const canViewWarehousingStock = has(app_permissions.warehousing.stock.view);
    const canViewWarehousingDispatch = has(app_permissions.warehousing.dispatch.view);
    const canViewWarehousingTransfer = has(app_permissions.warehousing.transfer.view);
    const canViewWarehousingRefurbishment = has(app_permissions.warehousing.refurbishment.view);
    const canViewWarehousingDestruction = has(app_permissions.warehousing.destruction.view);
    const canViewWarehousingBilling = has(app_permissions.warehousing.billing.view);
    const canViewWarehousing = canViewWarehousingOverview
        || canViewWarehousingItems
        || canViewWarehousingStockEntry
        || canViewWarehousingStock
        || canViewWarehousingDispatch
        || canViewWarehousingTransfer
        || canViewWarehousingRefurbishment
        || canViewWarehousingDestruction
        || canViewWarehousingBilling;
    const canViewProjectsAndWarehousing = canViewLogisticsProjects || canViewPosmProjects || canViewWarehousing;

    const canViewFleetDashboard = hasAnyScope(app_permissions.fleet.dashboard.view);
    const canViewFleetDrivers = has(app_permissions.fleet.drivers.view);
    const canViewFleetVehicles = has(app_permissions.fleet.vehicles.view);
    const canViewFleetDocuments = has(app_permissions.fleet.documents.view);
    const canViewFleetProfitability = has(app_permissions.fleet.profitability.view);
    const canViewFleetTelematics = has(app_permissions.fleet.telematics.view);
    const canManageFleetTelematics = has(app_permissions.fleet.telematics.manage);
    const canViewFleetGps = canViewFleetTelematics || canManageFleetTelematics;
    const canViewFleetTrailers = canViewFleetVehicles;
    const canViewFleetTrailerTypes = canViewFleetVehicles;
    const canViewFleetRentals = has(app_permissions.fleet.rental.view);
    const canViewFleetRentalUsage = has(app_permissions.fleet.rental.usage.view);
    const canViewFleetRentalSettlements = has(app_permissions.fleet.rental.settlement.view);

    const canViewMobilizationOverview = hasAll([
        app_permissions.fleet.mobilization.records.view,
        app_permissions.fleet.mobilization.overview.view
    ]);
    const canViewMobilizationEntries = has(app_permissions.fleet.mobilization.records.view);
    const canViewMobilizationPlanning = canViewMobilizationOverview;
    const canCreateMobilizationEntry = has(app_permissions.fleet.mobilization.records.create);
    const canViewMobilizationChangeRequests = has(app_permissions.fleet.mobilization.change_requests.view);
    const canViewMobilizationHistory = has(app_permissions.fleet.mobilization.history.view);
    const canViewMobilizationTimesheets = has(app_permissions.fleet.mobilization.timesheets.view);
    const canViewMobilizationSalaryRules = has(app_permissions.fleet.mobilization.records.view);
    const canViewFleetMobilization = canViewMobilizationOverview
        || canViewMobilizationEntries
        || canViewMobilizationPlanning
        || canCreateMobilizationEntry
        || canViewMobilizationChangeRequests
        || canViewMobilizationHistory
        || canViewMobilizationTimesheets
        || canViewMobilizationSalaryRules;

    const canViewMaintenanceOverview = has(app_permissions.fleet.maintenance.overview.view);
    const canViewMaintenanceWorkOrders = has(app_permissions.fleet.maintenance.work_orders.view);
    const canViewMaintenancePreventive = has(app_permissions.fleet.maintenance.programs.view);
    const canViewMaintenanceInspections = has(app_permissions.fleet.maintenance.inspections.view);
    const canViewMaintenanceParts = has(app_permissions.fleet.maintenance.parts.view);
    const canViewMaintenanceAvailability = has(app_permissions.fleet.maintenance.availability.view);
    const canViewMaintenanceAnalytics = has(app_permissions.fleet.maintenance.analytics.view);
    const canViewFleetMaintenance = canViewMaintenanceOverview
        || canViewMaintenanceWorkOrders
        || canViewMaintenancePreventive
        || canViewMaintenanceInspections
        || canViewMaintenanceParts
        || canViewMaintenanceAvailability
        || canViewMaintenanceAnalytics;
    const canViewFuelManagementOverview = hasAnyScope(app_permissions.fuel_management.reports.view);
    const canViewFuelMarketplace = has(app_permissions.fuel_management.marketplace.view);
    const canManageFuelConnections = has(app_permissions.fuel_management.connections.manage);
    const canViewFuelTransactions = has(app_permissions.fuel_management.transactions.view);
    const canReconcileFuelTransactions = has(app_permissions.fuel_management.transactions.reconcile);
    const canViewFuelReports = has(app_permissions.fuel_management.reports.view);
    const canViewFuelManagement = canViewFuelManagementOverview
        || canViewFuelMarketplace
        || canManageFuelConnections
        || canViewFuelTransactions
        || canReconcileFuelTransactions
        || canViewFuelReports;
    const canViewFleet = canViewFleetDashboard
        || canViewFleetDrivers
        || canViewFleetVehicles
        || canViewFleetDocuments
        || canViewFleetProfitability
        || canViewFleetGps
        || canViewFleetTrailers
        || canViewFleetTrailerTypes
        || canViewFleetRentals
        || canViewFleetMobilization
        || canViewFleetMaintenance
        || canViewFuelManagement;

    const canViewFinanceDashboard = hasAnyScope(app_permissions.accounts.reports.view);
    const canViewChartOfAccounts = has(app_permissions.chart_of_accounts.accounts.view);
    const canViewOrders = has(app_permissions.order.records.view);
    const canViewSalesOrders = canViewOrders;
    const canViewPurchaseOrders = canViewOrders;
    const canViewExpenses = has(app_permissions.expense.records.view);
    const canCreateExpense = has(app_permissions.expense.records.create);
    const canViewExpenseApprovals = has(app_permissions.expense.approval.view);
    const canViewExpensePosting = has(app_permissions.expense.posting.view);
    const canViewFinanceExpenses = canViewExpenses || canCreateExpense || canViewExpenseApprovals || canViewExpensePosting;
    const canViewPettyCash = has(app_permissions.workspace.petty_cash.view);
    const canViewWorkspace = canViewPettyCash || canViewAiChat
        || canViewWasenderChat
        || canViewNotifications
        || canViewTasks
        || canViewIncidents
        || canViewReportBuilder
        || canViewHrSelf
        || canViewHrManager;

    const canViewReceivablesToInvoice = has(app_permissions.accounts.invoice.view);
    const canCreateManualReceivableLine = has(app_permissions.accounts.invoice.create);
    const canViewCustomerInvoices = has(app_permissions.accounts.invoice.view);
    const canCreateManualInvoiceDraft = has(app_permissions.accounts.invoice.create);
    const canViewCustomerReceipts = has(app_permissions.accounts.receipt.view);
    const canViewDebitNotes = has(app_permissions.accounts.debit_note.view);
    const canViewReceivables = canViewReceivablesToInvoice
        || canCreateManualReceivableLine
        || canViewCustomerInvoices
        || canCreateManualInvoiceDraft
        || canViewCustomerReceipts
        || canViewDebitNotes || has(app_permissions.accounts.customer_credit_note.view);

    const canViewPayablesToBill = has(app_permissions.accounts.bill.view);
    const canCreateManualPayableLine = has(app_permissions.accounts.bill.create);
    const canViewVendorBills = has(app_permissions.accounts.bill.view);
    const canViewApMatching = has(app_permissions.accounts.bill.view);
    const canManageMatchingPolicies = has(app_permissions.accounts.bill.edit);
    const canViewPaymentProposals = has(app_permissions.accounts.voucher.view);
    const canViewVendorStatements = has(app_permissions.accounts.bill.view);
    const canCreateNonPoBillDraft = has(app_permissions.accounts.bill.create);
    const canViewVouchers = has(app_permissions.accounts.voucher.view);
    const canViewCreditNotes = has(app_permissions.accounts.credit_note.view);
    const canViewPayables = canViewPayablesToBill
        || canCreateManualPayableLine
        || canViewVendorBills
        || canViewApMatching
        || canManageMatchingPolicies
        || canViewPaymentProposals
        || canViewVendorStatements
        || canCreateNonPoBillDraft
        || canViewVouchers
        || canViewCreditNotes || has(app_permissions.accounts.vendor_debit_note.view);

    const canViewBankAccounts = has(app_permissions.accounts.bank_account_entry.view);
    const canViewBanks = has(app_permissions.accounts.bank_account_entry.view);
    const canViewPaymentTransactions = has(app_permissions.accounts.voucher.view);
    const canViewWorkforceFinance = has(app_permissions.accounts.workforce_finance.view);
    const canViewBankReconciliationDashboard = has(app_permissions.accounts.bank_reconciliation.view);
    const canViewBankStatements = has(app_permissions.accounts.bank_reconciliation.view);
    const canViewReconciliationReports = has(app_permissions.accounts.bank_reconciliation.view);
    const canManageReconciliationRules = has(app_permissions.accounts.bank_reconciliation.manage);
    const canManageReconciliationExceptions = has(app_permissions.accounts.bank_reconciliation.manage);
    const canViewBanking = canViewBankAccounts
        || canViewBanks
        || canViewPaymentTransactions
        || canViewWorkforceFinance
        || canViewBankReconciliationDashboard
        || canViewBankStatements
        || canViewReconciliationReports
        || canManageReconciliationRules
        || canManageReconciliationExceptions;

    const canViewJournalEntries = has(app_permissions.accounts.journal.view);
    const canViewCostCenters = has(app_permissions.accounts.cost_center.view);
    const canManageAccountingPeriodLocks = has(app_permissions.accounts.period_lock.manage);
    const canManageManualEntryControls = has(app_permissions.accounts.manual_entry.manage);
    const canViewAccountingControls = canManageAccountingPeriodLocks || canManageManualEntryControls;
    const canViewGeneralLedger = has(app_permissions.accounts.reports.view);
    const canViewPartnerLedger = has(app_permissions.accounts.reports.view);
    const canViewLedgers = canViewGeneralLedger || canViewPartnerLedger;
    const canViewAccounting = canViewJournalEntries
        || canViewCostCenters
        || canViewAccountingControls
        || canViewLedgers;

    const canViewFinanceReports = has(app_permissions.accounts.reports.view);
    const canViewAccountsPayableInvoices = has(app_permissions.accounts.invoice.view);
    const canViewAccountsPayableReceipts = has(app_permissions.accounts.receipt.view);
    const canViewAccountsPayable = canViewAccountsPayableInvoices || canViewAccountsPayableReceipts;
    const canViewFinance = canViewFinanceDashboard
        || canViewChartOfAccounts
        || canViewOrders
        || canViewFinanceExpenses
        || canViewReceivables
        || canViewPayables
        || canViewBanking
        || canViewAccounting
        || canViewFinanceReports
        || canViewAccountsPayable;

    const canManageSubscription = true;
    const canViewCompanySettings = permissionService.hasTenantAccessContext();
    const canViewCompanyGroups = permissionService.hasTenantAccessContext();
    const canViewRegions = has(app_permissions.warehousing.setup.view);
    const canViewLocationZones = has(app_permissions.warehousing.setup.view);
    const canViewWarehouses = has(app_permissions.warehousing.setup.view);
    const canViewLocations = has(app_permissions.location.records.view);
    const canManageTenantMasterDataImport = has(app_permissions.onboarding.manage);
    const canViewCompanySetup = canViewCompanySettings || canViewCompanyGroups || canViewRegions
        || canViewLocationZones || canViewWarehouses || canViewLocations || canManageTenantMasterDataImport;
    const canViewProducts = has(app_permissions.order.products.view);
    const canConfigureExpenseWorkflow = has(app_permissions.expense.approval.configure);
    const canViewFinanceSetup = canViewProducts || canConfigureExpenseWorkflow;

    const canManageWorkflow = has(app_permissions.workflow.manage);
    const canManageFlexFields = has(app_permissions.flex_fields.manage);
    const canViewWasenderSetup = has(app_permissions.wasender.setup.view);
    const canViewBusinessEvents = has(app_permissions.business_events.view);
    const canViewDeveloperPlatform = has(app_permissions.developer_platform.view);
    const canViewSystemSetup = canManageWorkflow
        || canManageFlexFields
        || canViewWasenderSetup
        || canViewBusinessEvents
        || canViewDeveloperPlatform
        || canViewFuelMarketplace;

    const canManageWarehousingStorageRates = has(app_permissions.warehousing.setup.manage_rates);
    const canViewWarehousingSetup = has(app_permissions.warehousing.setup.view);
    const canViewWarehousingSetupMenu = canManageWarehousingStorageRates || canViewWarehousingSetup;
    const canViewAdministration = canManageSubscription
        || canViewCompanySetup
        || canViewFinanceSetup
        || canViewSystemSetup
        || canViewWarehousingSetupMenu;

    return {
        canViewProfile,
        canViewAiChat,
        canViewWasenderChat,
        canViewNotifications,
        canViewTasks,
        canViewIncidents,
        canViewReportBuilder,
        canViewWorkspace,
        canViewPettyCash,
        canViewAudit,
        canViewHr,
        canViewHrDashboard,
        canViewHrEmployees,
        canViewHrOnboarding,
        canViewHrRecruitment,
        canViewHrLearning,
        canViewHrLabor,
        canViewHrPerformance,
        canViewHrCases,
        canViewHrSelf,
        canViewHrManager,
        canViewHrAnalytics,
        canViewHrLifecycle,
        canViewHrDocuments,
        canViewHrAdminOperations,
        canViewHrDocumentTypes,
        canViewHrReadiness,
        canViewHrLeave,
        canViewHrTime,
        canViewHrBiometric,
        canViewHrCountryPacks,
        canViewHrRoster,
        canViewHrPayroll,
        canViewHrSetup,
        canViewHrMigration,
        canViewCrmDashboard,
        canViewCrmLeads,
        canViewCrmProspects,
        canViewCrmClients,
        canViewCrmAccounts,
        canViewCrmMerchandisers,
        canViewCrmAssignments,
        canViewCrmQuotations,
        canManageCustomerPortalAccess,
        canViewCrm,
        canViewContracts,
        canViewPartyClients,
        canViewPartyContacts,
        canViewPartners,
        canViewCommercial,
        canViewLogisticsProjects,
        canViewFieldWork,
        canViewFieldWorkEquipment,
        canViewFieldWorkRates,
        canViewFieldWorkFinance,
        canViewShipmentDashboard,
        canCreateShipment,
        canImportShipments,
        canViewDeliveryRateCards,
        canViewInternalTransportCosts,
        canViewShipments,
        canViewShipmentDeliveries,
        canViewTransportReleases,
        canViewTransportPlans,
        canCreateTransportPlans,
        canViewShipmentOrders,
        canViewClearance,
        canCreateClearance,
        canViewClearanceServices,
        canViewCustomsClearance,
        canViewContainerDashboard,
        canViewContainerCases,
        canViewContainerSetup,
        canViewContainerTracking,
        canViewShipmentSection,
        canViewPosmProjects,
        canViewWarehousingOverview,
        canViewWarehousingItems,
        canViewWarehousingStockEntry,
        canViewWarehousingStock,
        canViewWarehousingDispatch,
        canViewWarehousingTransfer,
        canViewWarehousingRefurbishment,
        canViewWarehousingDestruction,
        canViewWarehousingBilling,
        canViewWarehousing,
        canViewProjectsAndWarehousing,
        canViewFleetDashboard,
        canViewFleetDrivers,
        canViewFleetVehicles,
        canViewFleetDocuments,
        canViewFleetProfitability,
        canViewFleetTelematics,
        canManageFleetTelematics,
        canViewFleetGps,
        canViewFleetTrailers,
        canViewFleetTrailerTypes,
        canViewFleetRentals,
        canViewFleetRentalUsage,
        canViewFleetRentalSettlements,
        canViewMobilizationOverview,
        canViewMobilizationEntries,
        canViewMobilizationPlanning,
        canCreateMobilizationEntry,
        canViewMobilizationChangeRequests,
        canViewMobilizationHistory,
        canViewMobilizationTimesheets,
        canViewMobilizationSalaryRules,
        canViewFleetMobilization,
        canViewMaintenanceOverview,
        canViewMaintenanceWorkOrders,
        canViewMaintenancePreventive,
        canViewMaintenanceInspections,
        canViewMaintenanceParts,
        canViewMaintenanceAvailability,
        canViewMaintenanceAnalytics,
        canViewFleetMaintenance,
        canViewFuelManagementOverview,
        canViewFuelMarketplace,
        canManageFuelConnections,
        canViewFuelTransactions,
        canReconcileFuelTransactions,
        canViewFuelReports,
        canViewFuelManagement,
        canViewFleet,
        canViewFinanceDashboard,
        canViewChartOfAccounts,
        canViewOrders,
        canViewSalesOrders,
        canViewPurchaseOrders,
        canViewExpenses,
        canCreateExpense,
        canViewExpenseApprovals,
        canViewExpensePosting,
        canViewFinanceExpenses,
        canViewReceivablesToInvoice,
        canCreateManualReceivableLine,
        canViewCustomerInvoices,
        canCreateManualInvoiceDraft,
        canViewCustomerReceipts,
        canViewDebitNotes,
        canViewReceivables,
        canViewPayablesToBill,
        canCreateManualPayableLine,
        canViewVendorBills,
        canViewApMatching,
        canManageMatchingPolicies,
        canViewPaymentProposals,
        canViewVendorStatements,
        canCreateNonPoBillDraft,
        canViewVouchers,
        canViewCreditNotes,
        canViewPayables,
        canViewBankAccounts,
        canViewBanks,
        canViewPaymentTransactions,
        canViewWorkforceFinance,
        canViewBankReconciliationDashboard,
        canViewBankStatements,
        canViewReconciliationReports,
        canManageReconciliationRules,
        canManageReconciliationExceptions,
        canViewBanking,
        canViewJournalEntries,
        canViewCostCenters,
        canManageAccountingPeriodLocks,
        canManageManualEntryControls,
        canViewAccountingControls,
        canViewGeneralLedger,
        canViewPartnerLedger,
        canViewLedgers,
        canViewAccounting,
        canViewFinanceReports,
        canViewAccountsPayableInvoices,
        canViewAccountsPayableReceipts,
        canViewAccountsPayable,
        canViewFinance,
        canManageSubscription,
        canViewRegions,
        canViewLocationZones,
        canViewWarehouses,
        canViewLocations,
        canViewCompanySettings,
        canViewCompanyGroups,
        canManageTenantMasterDataImport,
        canViewCompanySetup,
        canViewProducts,
        canConfigureExpenseWorkflow,
        canViewFinanceSetup,
        canManageWorkflow,
        canManageFlexFields,
        canViewWasenderSetup,
        canViewBusinessEvents,
        canViewDeveloperPlatform,
        canViewSystemSetup,
        canManageWarehousingStorageRates,
        canViewWarehousingSetup,
        canViewWarehousingSetupMenu,
        canViewAdministration
    };
}
